var CryptoJS = require("crypto-js");

const key = CryptoJS.enc.Utf8.parse("5647895214001454");
const iv = CryptoJS.enc.Utf8.parse("5647895214001454");
//import store from "../../store";
const com = {
  Encrypt: function (string) {
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(string), key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted;
  },
  Decrypt: function (string) {
    var decrypted = CryptoJS.AES.decrypt(string, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  },
  GetEncryptedDateTime: function () {
    var _date = Date.now().toString() + "+ Standard GMT Time ";
    var encrypt = com.Encrypt(_date).toString();
    return encrypt;
  },
  setRefreshTokenCookie: function (key) {
    var s = process.env.NODE_ENV == "development" ? "" : "secure;";
    var d = new Date();
    d.setTime(d.getTime() + 2 * 60 * 60 * 1000); // two hrs
    var expires = "expires=" + d.toGMTString();
    document.cookie =
      "_RRID=" +
      key +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
  },
  GetRefreshToken: function (cname = "_RRID") {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      if (c) {
        c = c.toString().trim();
      }
      if (c.indexOf(name) == 0) {
        var _rToken = c.substring(name.length, c.length);
        _rToken = this.Encrypt(_rToken).toString();
        return _rToken;
      }
    }
    return "";
  }
};

export default com;